import { Arrays } from "src/modules/utils/shared/arrays";
import { Objects } from "src/modules/utils/shared/objects";
import { BackendResponseItem } from "./backend-response-item.model";
import { BackendResponseStatus } from "./backend-response-status.enum";

export class BackendResponse extends Error {

    isBackendResponse = "a1be17bef39cf8e3";

    static error(message: string, errorId = 0, recoverable = true): BackendResponse {
        return new BackendResponse([new BackendResponseItem(BackendResponseStatus.error, message, errorId, recoverable)]);
    }

    static success(message: string, errorId = 0): BackendResponse {
        return new BackendResponse([new BackendResponseItem(BackendResponseStatus.success, message, errorId)]);
    }

    static from(o: any): BackendResponse {
        return o.isBackendResponse == "a1be17bef39cf8e3" ? Objects.fromPlain(BackendResponse, o as Partial<BackendResponse>) : null;
    }

    static getFromException(ex: any): BackendResponse {
        let oex = ex;
        if ("response" in ex) {
            ex = ex.response;
        }
        if ("error" in ex && ex.error != null && "status" in ex) {
            try {
                let ex2 = Objects.fromJson(Objects.toString(ex.error));
                if (ex2.isBackendResponse == "a1be17bef39cf8e3") {
                    ex = ex2;
                }
            }
            catch (error) {
                throw new Error("Fehler beim Interpretieren der Rückgabe " + Objects.toJson(oex) + "\n" + Objects.toJson(error));
            }

        }
        return ex instanceof BackendResponse ? ex : ex.isBackendResponse == "a1be17bef39cf8e3" ? Objects.fromPlainUnsafe(BackendResponse, ex) : "message" in ex ? BackendResponse.error(ex.message as string) : null;
    }

    static getMessageFromException(ex: any): string {
        return BackendResponse.getFromException(ex)?.getMessage();
    }

    constructor(public items: BackendResponseItem[]) {
        super("");
        this.name = "BackendResponse";
    }

    getMessage(): string {
        return Arrays.itemsToString(this.items, "\n", item => item.message);
    }

    isErrorId(id: number): boolean {
        return this.items.some(bri => bri.errorId == id);
    }
}